import React from 'react'
import { Link } from "react-router-dom";
import GoogleMap from '../Contact/GoogleMap';

const Footer = () => {
    return (
        <>

            <div
                className="container-fluid footer position-relative bg-dark text-white-50 mt-5 py-5 px-4 px-lg-5 wow fadeIn"
                data-wow-delay="0.1s"
            >
                <div className="row g-5 py-5">
                    <div className="col-lg-4 pe-lg-5">
                        <Link to="/" className="navbar-brand">
                            <h1 className="display-5 text-primary m-auto">ProArt</h1>
                            <h6 className="text-primary" style={{ "marginLeft": '10%' }}>Digital Studio</h6>
                        </Link>
                        <p>
                            Address :-
                        </p>
                        <p>
                            <i className="fa fa-map-marker-alt me-2" />
                            Yadav Nagar, near about bhagwanpur brize, Muzaffarpur, Bihar 843165
                        </p>
                        <p>
                            <i className="fa fa-phone-alt me-2" />
                            +91 6205430785
                        </p>
                        <p>
                            <i className="fa fa-envelope me-2" />
                            proartdigitalstudio@gmail.com
                        </p>
                        <div className="d-flex justify-content-start mt-4">
                            <Link
                                className="btn btn-square btn-outline-primary rounded-circle me-2"
                                to="#"
                            >
                                <i className="fab fa-youtube" />
                            </Link>
                            <Link
                                className="btn btn-square btn-outline-primary rounded-circle me-2"
                                to="#"
                            >
                                <i className="fab fa-facebook-f" />
                            </Link>
                            <Link
                                className="btn btn-square btn-outline-primary rounded-circle me-2"
                                to="#"
                            >
                                <i className="fab fa-instagram" />
                            </Link>
                        </div>
                    </div>
                    <div className="col-lg-4 ps-lg-8">
                        <div className="row g-5">
                            <div className="col-sm-6">
                                <h4 className="text-light mb-4">Useful Links</h4>
                                <Link className="btn btn-link" to="/about">
                                    About Us
                                </Link>
                                <Link className="btn btn-link" to="/contact">
                                    Contact Us
                                </Link>
                                <Link className="btn btn-link" to="/service">
                                    Our Services
                                </Link>
                                <Link className="btn btn-link" to="/product">
                                    Our Projects
                                </Link>
                                <Link className="btn btn-link" to="/team">
                                Our Teams
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 ps-lg-3">
                        <div className="row g-5">
                            <div className="col-sm-6 col-lg-12">
                                <h4 className="text-light">Location</h4>
                                <GoogleMap />
                            </div>
                        </div>
                    </div>

                </div>
            </div>

        </>
    )
}

export default Footer
